import {PropsWithChildren, useEffect} from 'react';
import IconClose from '../assets/images/icon-close.svg';
import styled, {css} from 'styled-components';

type Props = PropsWithChildren<{
  isOpen: boolean;
  onClose?: () => void;
  isBig?: boolean;
}>;

const Popup = ({children, isOpen, onClose, isBig}: Props) => {
  useEffect(() => {
    if (isOpen) {
      document.querySelector('body')?.classList.add('noscroll');
    } else {
      document.querySelector('body')?.classList.remove('noscroll');
    }
  }, [isOpen]);

  if (isOpen) {
    return (
      <Container>
        <Inner isBig={isBig}>
          <ButtonClose onClick={onClose}>
            <img src={IconClose} alt="close" />
          </ButtonClose>
          <Body>
            <Content>{children}</Content>
          </Body>
        </Inner>
      </Container>
    );
  }

  return null;
};

export default Popup;

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 2rem;
  background-color: rgba(0, 0, 0, 0.7);
  overflow: auto;

  @media ${(props) => props.theme.breakpoints.phone} {
    padding: 0;
  }
`;

const Inner = styled.div<{isBig?: boolean}>`
  position: relative;
  background-color: ${(props) => props.theme.colors.white};
  padding: 3rem;
  border-radius: 10px;
  width: 100%;
  max-width: 800px;

  ${(p) =>
    p.isBig &&
    css`
      max-width: 1024px;
    `}

  @media ${(props) => props.theme.breakpoints.phone} {
    padding: 1rem;
    border-radius: 0;
  }
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Content = styled.div`
  font-size: 1.2rem;
  line-height: 1.4;
  width: 100%;

  @media ${(props) => props.theme.breakpoints.phone} {
    font-size: 1rem;
  }
`;

const ButtonClose = styled.button.attrs({type: 'button'})`
  width: 3rem;
  height: 3rem;
  position: absolute;
  top: 1rem;
  right: 1rem;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  border: none;
  border-radius: 0.5rem;
  padding: 0;
  cursor: pointer;

  &:hover {
    background-color: ${(p) => p.theme.colors.gray200};
  }

  img {
    width: 100%;
    display: block;
  }
`;
